module.exports = __webpack_public_path__ + "static/media/diktat-28.a4653422.mp3";